import { render, staticRenderFns } from "./CourseUser.vue?vue&type=template&id=fe640994&"
import script from "./CourseUser.vue?vue&type=script&lang=js&"
export * from "./CourseUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports